import { render, staticRenderFns } from "./yinsi.vue?vue&type=template&id=b40d4cee&scoped=true&"
import script from "./yinsi.vue?vue&type=script&lang=js&"
export * from "./yinsi.vue?vue&type=script&lang=js&"
import style0 from "./yinsi.vue?vue&type=style&index=0&id=b40d4cee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b40d4cee",
  null
  
)

export default component.exports